'use client';

import { IconButton } from '@yaradigitallabs/ahua-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface HeaderNavigatorProps {
  title: string;
  className?: string;
}

const HeaderNavigator: React.FC<HeaderNavigatorProps> = ({
  title,
  className = '',
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={`flex gap-4 items-center px-4 py-2 w-full fixed top-[56px] bg-white ${className}`.trim()}
    >
      <IconButton
        size="xs"
        onClick={() => navigate(-1)}
        className="p-3 bg-none"
        title="Back Navigation"
        icon="ArrowLeft"
        colorConcept="brand"
      />
      <h1 className="text-lg font-black">{title}</h1>
    </div>
  );
};

export default HeaderNavigator;
